import { Injectable } from '@angular/core';

import { NzMenuBaseService } from 'ant-reset-private/core';

@Injectable()
export class NzMenuDropdownService extends NzMenuBaseService {
  isInDropDown = true;
}
